  
<template>
    <div>
        <form action="">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title has-text-white">Add a Service Code and Parts</p>
                        <button
                            type="button"
                            class="delete"
                            @click="$emit('close')"/>
                    </header>
                    <section class="modal-card-body has-background-dvodark">
                        <!-- <p class="has-text-white">
                            {{warrantyObj}}
                        </p> -->
                        <b-field label="Service Code">
                            <!-- Make autocomplete actually auto complete -->
                            <b-autocomplete
                                v-model="warrantyObj.service_code"
                                placeholder="Enter the Service Code"
                                :keep-first="true"
                                :open-on-focus="true"
                                :data="serviceCodes"
                                field="code"
                                :clearable="true"
                            >
                                <template v-slot="props">
                                    <strong>{{props.option.code}}</strong>: {{props.option.description}}
                                </template>
                            </b-autocomplete>
                        </b-field>
                        <div v-for="(part, index) in warrantyObj.parts" :key="index">
                            <b-field label="Part Used/Quantity" grouped>
                                <b-select expanded v-model="warrantyObj.parts[index]" :disabled="isServiceCodeEmpty" @input="handleInput(index)">
                                    <option class="has-text-white" selected="selected">
                                    </option>
                                    <option class="has-text-white" v-for="(part, index) in parts" :value="part"
                                        :key="index">
                                        {{ part.number }}
                                    </option>
                                </b-select>
                                <b-numberinput controls-position="compact" :min="1"  :default="1" v-model="warrantyObj.parts[index].quantity" :disabled="isServiceCodeEmpty" required></b-numberinput>
                                <b-button class="is-danger" @click="removePartField()"><i class="fas fa-minus-circle"></i></b-button>
                            </b-field>
                        </div>
                        <b-button class="mt-2 is-dvogreen" @click="addPartField()" :disabled="isServiceCodeEmpty"><i class="fas fa-plus-circle" ></i> Add Part</b-button>
                    </section>
                    <footer class="modal-card-foot">
                        <b-button class="is-dvogreen" @click="$emit('pass-warranty-obj', warrantyObj); $emit('close');">Finish Request</b-button>
                    </footer>
                </div>
        </form>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { getServices, /*getParts,*/ partsFromServiceCode} from '../graphql/queries'
export default {
    data(){
        return {
            warrantyObj: {
            warranty_id: null,
            service_code: null,
            parts: [{
                part_number: null,
                quantity: 1

            }]
            },
            serviceCodes: [],
            parts: []
        }
    },
    computed: {
        computedServiceCode(){
            return this.warrantyObj.service_code
        },
        isServiceCodeEmpty(){
            if (this.warrantyObj.service_code === "" || this.warrantyObj.service_code === null || this.warrantyObj.service_code === false){
                return true
            } else {
                return false
            }
        }
    },
    watch: {
        computedServiceCode: async function () {
            this.getPartsByService(this.computedServiceCode)
        },
    },
    methods:{
        async getServiceCodes(){
            const Services = await API.graphql({
                query: getServices,
            });
            
            this.serviceCodes = Services.data.getServices
        },
        handleInput (index){
            this.warrantyObj.parts[index].quantity = 1
        },
        // async getParts(){
        //     const Parts = await API.graphql({
        //         query: getParts,
        //     });
        //     this.parts = Parts.data.getParts
        //     this.parts.unshift({part_number: null, quantity: 1})
        //     this.parts = this.parts.map(obj => (obj.quantity = 1));
        //     console.log(this.parts)
        // },
        async getPartsByService(service_code){
            const partsHolder = await API.graphql({
                query: partsFromServiceCode,
                variables:{
                    input:{
                    request_type: 'get_parts_by_service',
                    service_code: service_code
                    }
                }
            });
            this.parts.unshift({part_number: null, quantity: 1})
            this.parts = partsHolder.data.partsFromServiceCode
            // this.parts.unshift({part_number: null, quantity: 1})
            // this.parts.map(obj => (obj.quantity = 1));
        },
        addPartField(){
            this.warrantyObj.parts.push(
                this.parts[0]
            );
        },
        removePartField(index){
            this.warrantyObj.parts.splice(index, 1)
        }
    },
    created(){
        this.getServiceCodes()
    }
}
</script>

<style lang="scss">
</style>